export const inclusionOptionMap = {
    includeOnly: "includeOnly",
    excludeOnly: "excludeOnly",
    any: "any",
} as const;
export type InclusionOption = (typeof inclusionOptionMap)[keyof typeof inclusionOptionMap];

// Binary presence toggle (include/exclude only). Use this for two-option inclusion radios that must
// not surface the "any" option.
export const binaryInclusionOptions = [inclusionOptionMap.includeOnly, inclusionOptionMap.excludeOnly] as const;

export const operatorOptionMap = {
    and: "and",
    or: "or",
} as const;
export type OperatorOption = (typeof operatorOptionMap)[keyof typeof operatorOptionMap];
